import { NODE_ENV } from 'constants/node-env';
import { WINDOW_ORIGIN } from 'constants/general';

export function registerServiceWorks() {
  if (
    window.location.origin !== WINDOW_ORIGIN.OPAQUE_NULL &&
    'serviceWorker' in navigator &&
    process.env.NODE_ENV === NODE_ENV.PRODUCTION
  ) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          // Force an SW script re-check sooner than Chrome's default interval; ignore offline/network failures
          registration.update().catch(() => undefined);
          console.log(
            'Caching serviceWorker registration successful with scope: ',
            registration.scope
          );
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }
}
